import { render, staticRenderFns } from "./SaleEditRowExtraInfoFieldsSettingsEdit.vue?vue&type=template&id=70f358c8"
import script from "./SaleEditRowExtraInfoFieldsSettingsEdit.vue?vue&type=script&lang=ts"
export * from "./SaleEditRowExtraInfoFieldsSettingsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f358c8')) {
      api.createRecord('70f358c8', component.options)
    } else {
      api.reload('70f358c8', component.options)
    }
    module.hot.accept("./SaleEditRowExtraInfoFieldsSettingsEdit.vue?vue&type=template&id=70f358c8", function () {
      api.rerender('70f358c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleEditRowExtraInfoFieldsSettingsEdit.vue"
export default component.exports